export default "__VITE_ASSET__M7f7Yj6k__"